module.exports = __webpack_public_path__ + "img/news-07.d45a6f8b.jpg";